export default "__VITE_ASSET__D_wij81d__"